document.addEventListener('bundler:loaded', function (e) {
  window.bndlr.updateCartDiscounts();
});

document.addEventListener('bundler:total_cart_values', function (e) {
  const { discounted_cart_object = null } = e.detail;

  if (discounted_cart_object && discounted_cart_object.items) {
    discounted_cart_object.items.forEach((item) => {
      const itemElements = document.querySelectorAll(`[data-cart-variant="${item.variant_id}"]`);
      
      itemElements.forEach((itemElement) => {
        const oldPriceElement = itemElement.querySelector('[data-old-price]');
        const newPriceElement = itemElement.querySelector('[data-new-price]');
        const quantityElement = itemElement.querySelector('.item-quantity');
        
        if (oldPriceElement && newPriceElement && quantityElement) {
          const originalPrice = (item.original_price / 100).toFixed(2).replace('.', ',');
          const discountedPrice = (item.final_price / 100).toFixed(2).replace('.', ',');
          
          oldPriceElement.textContent = `€${originalPrice}`;
          newPriceElement.textContent = `€${discountedPrice}`;
          
          if (item.original_price !== item.final_price) {
            oldPriceElement.classList.add('line-through', 'text-gray-500');
            newPriceElement.classList.remove('hidden');
          } else {
            oldPriceElement.classList.remove('line-through', 'text-gray-500');
            newPriceElement.classList.add('hidden');
          }
          
          quantityElement.textContent = item.quantity;
        }
      });
    });
  }
});

// Dispatch initial event to initialize cart values
var cartEvent = new CustomEvent("bundler:total_cart_values", {
  detail: {
    total_amount_original: 0,
    discounted_cart_object: null
  }
});
document.dispatchEvent(cartEvent);